import { render, staticRenderFns } from "./KidsClubConfirmation.vue?vue&type=template&id=00d16564&scoped=true&"
import script from "./KidsClubConfirmation.vue?vue&type=script&lang=js&"
export * from "./KidsClubConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d16564",
  null
  
)

export default component.exports